import type { FormControl, ValidatorFn } from '@angular/forms';

export function upperLowerCase(): ValidatorFn {
  return (control: FormControl<string>): { upperLowerCase: true } | null => {
    const str = control.value;
    const hasUpper = str.toLowerCase() !== str;
    const hasLower = str.toUpperCase() !== str;
    return hasUpper && hasLower ? null : { upperLowerCase: true };
  };
}
